export interface SettingsCompanySignTypesRouter {
  goToSignTypes(): void;
  goToSignTypeEdit(id: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsCompanySignTypesRouter = Symbol(
  'SettingsCompanySignTypesRouter',
);
